/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Export_FailedInputs */

const vi_care_log_export_failed = /** @type {(inputs: Care_Log_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel nhật ký chăm sóc thất bại, thử lại sau`)
};

/**

* @param {Care_Log_Export_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_export_failed = /** @type {((inputs?: Care_Log_Export_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Export_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_export_failed(inputs)
});